// Environment configuration
export const config = {
  SUPABASE_URL: import.meta.env.VITE_SUPABASE_URL || "https://qctvfoisbpkgttaxsdip.supabase.co",
  SUPABASE_ANON_KEY: import.meta.env.VITE_SUPABASE_ANON_KEY || "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InFjdHZmb2lzYnBrZ3R0YXhzZGlwIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDMyODI0MjQsImV4cCI6MjA1ODg1ODQyNH0.Yt_Ej8Ej8Ej8Ej8Ej8Ej8Ej8Ej8Ej8Ej8Ej8Ej8Ej8",
  JWT_SECRET: import.meta.env.VITE_JWT_SECRET || "",
  DEFAULT_SENDER_EMAIL: import.meta.env.VITE_DEFAULT_SENDER_EMAIL || "Dommek <no-reply@dommek.com>",
  CLIENT_URL: import.meta.env.VITE_CLIENT_URL || "https://dommek.com",
  ENFORCE_LOGIN: import.meta.env.VITE_ENFORCE_LOGIN !== "false" // Default to true unless explicitly set to "false"
};

